import './Header.css';
import { useEffect, useRef, useState } from 'react';
import Menu from '../../navigation/Menu';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Header() {
    const [show, setShow] = useState(true);
    const lastScrollY = useRef(0);
    
    const { t } = useTranslation("common");
    const headerData = t("header", { returnObjects: true }) || {};
    
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY < 10) {
                setShow(true);
            } else if (currentScrollY > lastScrollY.current) {
                setShow(false);
            } else {
                setShow(true);
            }
            lastScrollY.current = currentScrollY;
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className='header' style={{ transform: show ? 'translateY(0)' : 'translateY(-100%)' }}>
            <Link to="/">
                <img className='header-logo' src={headerData.image} alt="Aivhy Logo" style={{ width: '350px' }} />
            </Link>
            <Menu />
        </header>
    );
}